import Helper from "@ember/component/helper";
import { assert } from "@ember/debug";
import { service } from "@ember/service";
import type IntlService from "ember-intl/services/intl";
import { SemeiaComorbidityCode } from "parog-web/models/comorbidities-and-allergies-changed-journal-event";
import type ICD10Service from "parog-web/services/icd10";

type Positional = Array<string>;

export interface ComorbidityDescriptionSignature {
  Args: {
    Positional: Positional;
  };
  Return: string;
}

export default class ComorbidityDescriptionHelper extends Helper<ComorbidityDescriptionSignature> {
  @service declare icd10: ICD10Service;
  @service declare intl: IntlService;

  override compute([icd10CodeOrDescription]: Positional): string {
    assert(
      `You must provide a string representing a comorbidity code or a custom comorbidity description as the first positional param to the 'comorbidity-name helper. You passed ${icd10CodeOrDescription}`,
      typeof icd10CodeOrDescription === "string"
    );

    const icd10Code = new SemeiaComorbidityCode(icd10CodeOrDescription)
      .icd10Code;

    // Return the provided string if our ICD10 service does not provide it
    if (!this.icd10.hasCode(icd10Code)) return icd10CodeOrDescription;

    return this.intl.t(`comorbidity.icd10.${icd10Code}`);
  }
}
